import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import {
  SectionMessage,
  SectionMessageType,
} from '../SectionMessage/SectionMessage';
import Text, { TextType } from '../../Text/Text';
import { classes } from './BookForSomeoneElseBanner.st.css';
import { BookForSomeoneElseBannerDataHooks } from './dataHooks';

export interface BookForSomeoneElseBannerProps {
  showPricingPlanNotice?: boolean;
}

const BookForSomeoneElseBanner: React.FC<BookForSomeoneElseBannerProps> = ({
  showPricingPlanNotice,
}) => {
  const { t } = useTranslation();

  return (
    <SectionMessage
      type={SectionMessageType.Default}
      withoutIcon
      className={classes.root}
      dataHook={BookForSomeoneElseBannerDataHooks.BANNER}
    >
      <Text type={TextType.Primary} tagName="p" className={classes.body}>
        {t('bookings.form.bookForSomeoneElse.banner.body')}
      </Text>
      {showPricingPlanNotice && (
        <Text
          type={TextType.Primary}
          tagName="p"
          className={classes.pricingPlanNotice}
          data-hook={BookForSomeoneElseBannerDataHooks.PRICING_PLAN_NOTICE}
        >
          {t('bookings.form.bookForSomeoneElse.banner.pricingPlanNotice')}
        </Text>
      )}
    </SectionMessage>
  );
};

export default BookForSomeoneElseBanner;
